<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <label class="form-label mb-0">Opções do campo</label>
      <BButton variant="soft-primary" size="sm" @click="adicionarOpcao">
        <i class="ri-add-line me-1"></i> Adicionar opção
      </BButton>
    </div>

    <div v-if="!localOptions.length" class="border rounded p-3 text-muted small bg-light-subtle">
      Nenhuma opção cadastrada.
    </div>

    <div v-for="(opcao, index) in localOptions" :key="opcao.uid" class="border rounded p-3 mb-2 bg-light-subtle">
      <BRow class="g-2 align-items-end">
        <BCol md="5">
          <label class="form-label">Etiqueta</label>
          <input v-model="opcao.label" type="text" class="form-control" placeholder="Ex.: Cliente VIP" @input="emitir" />
        </BCol>
        <BCol md="3">
          <label class="form-label">Valor técnico</label>
          <input v-model="opcao.valor" type="text" class="form-control" placeholder="cliente_vip" @input="emitir" />
        </BCol>
        <BCol md="2">
          <label class="form-label">Ordem</label>
          <input v-model.number="opcao.ordem" type="number" min="0" class="form-control" @input="emitir" />
        </BCol>
        <BCol md="1">
          <div class="form-check form-switch mt-4">
            <input v-model="opcao.ativo" class="form-check-input" type="checkbox" @change="emitir" />
          </div>
        </BCol>
        <BCol md="1" class="text-end">
          <BButton variant="soft-danger" size="sm" @click="removerOpcao(index)">
            <i class="ri-delete-bin-line"></i>
          </BButton>
        </BCol>
      </BRow>
    </div>
  </div>
</template>

<script>
let optionUid = 1;

export default {
  name: 'CampoPersonalizadoOpcoesEditor',
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      localOptions: [],
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localOptions = (value || []).map((opcao, index) => ({
          id: opcao.id,
          uid: opcao.uid || `opcao-${optionUid += 1}`,
          label: opcao.label || '',
          valor: opcao.valor || '',
          ordem: Number(opcao.ordem ?? index),
          ativo: opcao.ativo !== false,
        }));
      },
    },
  },
  methods: {
    emitir() {
      this.$emit(
        'update:modelValue',
        this.localOptions.map((opcao) => {
          const payload = { ...opcao };
          delete payload.uid;
          return payload;
        })
      );
    },
    adicionarOpcao() {
      this.localOptions.push({ uid: `opcao-${optionUid += 1}`, label: '', valor: '', ordem: this.localOptions.length, ativo: true });
      this.emitir();
    },
    removerOpcao(index) {
      this.localOptions.splice(index, 1);
      this.localOptions = this.localOptions.map((opcao, order) => ({ ...opcao, ordem: order }));
      this.emitir();
    },
  },
};
</script>